import { mdiChartBar, mdiDatabaseCheckOutline, mdiStorefrontOutline, mdiViewDashboardOutline } from '@mdi/js';
import i18n from '@/i18n';

/**
 * The API store and the API customer pages (PI-635). Shared by both portal
 * shapes: API-only tenants reach them from the API menu, full-portal users
 * from the Platform sidebar.
 */
const apiMeta = (titleKey, icon, path, { gated = true } = {}) => ({
  cauldron: 'platform',
  title: i18n.global.t(titleKey),
  icon,
  requiresAuth: true,
  hideNewsletter: true,
  hideFooter: true,
  favoritable: false,
  ...(gated ? { requiresFeatureFlag: 'api-docs-catalog' } : {}),
  breadcrumbs: [
    { label: i18n.global.t('api_store.nav.section'), to: '/api' },
    { label: i18n.global.t(titleKey), to: path },
  ],
});

export default [
  {
    meta: apiMeta('api_store.nav.overview', mdiViewDashboardOutline, '/api'),
    path: '/api',
    name: 'api.overview',
    component: () => import('../../features/api-store/pages/ApiOverviewPage.vue'),
  },
  {
    meta: apiMeta('api_store.nav.store', mdiStorefrontOutline, '/api/store'),
    path: '/api/store',
    name: 'api.store',
    component: () => import('../../features/api-store/pages/StorePage.vue'),
  },
  {
    // One dataset's store page; the breadcrumb leads back to the store list.
    // Gated like the store list: hidden in production with the store.
    meta: apiMeta('api_store.nav.store', mdiStorefrontOutline, '/api/store'),
    path: '/api/store/:datasetId',
    name: 'api.store.dataset',
    component: () => import('../../features/api-store/pages/StoreDatasetPage.vue'),
  },
  {
    // Not behind the store flag: anyone granted dataset API access must see
    // which datasets those are, even while the store itself is hidden.
    meta: apiMeta('api_store.nav.access', mdiDatabaseCheckOutline, '/api/access', { gated: false }),
    path: '/api/access',
    name: 'api.access',
    component: () => import('../../features/api-store/pages/ApiAccessPage.vue'),
  },
  {
    meta: apiMeta('api_store.nav.usage', mdiChartBar, '/api/usage'),
    path: '/api/usage',
    name: 'api.usage',
    component: () => import('../../features/api-store/pages/ApiUsagePage.vue'),
  },
];
